var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefingIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.977A1.477 1.477 0 0 0 3.93.503a1.5 1.5 0 0 0-1.404 1.589l.384 6.772c.034.553.492.983 1.046.983.555 0 1.018-.428 1.06-.982l.48-6.775c.003-.038.004-.075.004-.113ZM2.5 12.29a1.422 1.422 0 1 0 2.844 0 1.422 1.422 0 0 0-2.844 0Z"
  })));
}
export default SvgBriefingIconInfo;